import React, { useState } from 'react';
import { Button, Item, Popup } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import UploadImageModal from './UploadImageModal';

export interface IProjectImage {
  projectId: number;
  image: string | undefined;
  canEdit?: boolean;

  onSubmit(_projectId: number, _image: string): void;
}

const ProjectImage = (props: IProjectImage) => {
  const { projectId, image, canEdit, onSubmit } = props;
  const { t } = useTranslation();

  const [imageOpen, setImageOpen] = useState(false);

  const handleSubmitImage = (imageURL: string) => {
    setImageOpen(false);
    onSubmit(projectId, imageURL)
  };

  return (
    <>
      <Item.Image src={image ? image : '/default-image.png'} />
      {canEdit && (
        <Item.Extra style={{width: 30}}>
          <Popup
            content={t('uploadImage.editProjectImage')}
            trigger={
              <Button
                icon="edit outline"
                floated="left"
                style={{ marginLeft: -40, marginRight: 20 , backgroundColor: 'transparent'}}
                onClick={() => setImageOpen(true)}
              />
            }
          />
        </Item.Extra>
      )}
      <UploadImageModal
        open={imageOpen}
        title={t('uploadImage.editProjectImage')}
        onCancel={() => setImageOpen(false)}
        onSubmit={handleSubmitImage}
        currentImage={image}
      />
    </>
  );
};

export default ProjectImage;
